import { useEffect } from "react";
import { CircularProgress } from "@mui/material";
import "./apiLoader.css";

export default function ApiLoader({ loading }) {
  useEffect(() => {
    if (loading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  if (!loading) return null;

  return (
    <div className="loader-container">
      <CircularProgress color="inherit" />
    </div>
  );
}
